<template>
    <div>
        <Nothingness />

        <DenyEverything />

        <Money />

        <KlickenMaus />

        <CookieDisclaimer />

        <!--
        <Mandelbrot />
-->
        <!--
        <BandcampPlayer />
        -->

        <FindUs />

        <SignOut />

        <div class="wisdom purpular" style="font-size: 24pt;">
            <strong>STROMPOPPER</strong><br/>
            WARRANTY VOID
        </div>
    </div>
</template>

<script>

import Nothingness from "@/components/Nothingness";
import CookieDisclaimer from "@/components/CookieDisclaimer";
import BandcampPlayer from "@/components/BandcampPlayer";
import Money from "@/components/Money";
import KlickenMaus from "@/components/KlickenMaus";
import FindUs from "@/components/FindUs";
import Mandelbrot from "@/components/Mandelbrot";
import DenyEverything from "@/components/DenyEverything";
import SignOut from "@/components/SignOut";

export default {
    components: {
        SignOut,
        DenyEverything,
        Mandelbrot,
        KlickenMaus,
        Nothingness,
        CookieDisclaimer,
        BandcampPlayer,
        Money,
        FindUs
    },

    data() {
        return {

        };
    },

    mounted() {
    },

    methods: {

    }
}
</script>

<style scoped>

    .greybg {
        background: #333;
    }

    .redbg {
        background: #600;
    }

    .purpular {
        background: #202;
    }

    iframe {
        display: inline-block;
    }

    @media(max-width: 480px) {
        .wisdom {
        }
    }

    @media(min-width: 1280px) {
        .wisdom {
            font-size: 3vw;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue